import './CrearObra.scss';
import { Link, useParams } from 'react-router-dom';
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import { useEffect, useState } from 'react';
import { PaisesService } from '../../services/paises.service';
import { MonedasService } from '../../services/monedas.service';
import { TipoObrasService } from '../../services/tipoObras.service';
import { Pais } from '../../models/pais.model';
import Moneda from '../../models/moneda.model';
import TipoObra from '../../models/tipoObra.model';
import JefeEquipo from '../../models/jefeEquipo.model';
import { JefeEquiposService } from '../../services/jefeEquipos.service';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { dataDefault } from './dataDefault';
import { ProgramasService } from '../../services/programas.service';
import { ObraAppTemporal } from '../../models/obraAppTemporal.model';
import { NotificationsService } from '../../services/notifications.service';
import { ObrasService } from '../../services/obras.service';
import { NotificationAlert } from '../../models/notifications.model';
import { General } from '../../services/general';
import { onChangeFuntions } from '../create-program/Create-program';
import Swal from 'sweetalert2';
import ObraFilter from '../../models/obraFilter.model';
import { ObraApp } from '../../models/obraApp.model';
import EstadoEjecucion from '../../models/estadoEjecucion.model';
import { EstadosEjecucionService } from '../../services/estadosEjecucion.service';

export const CrearObra = () => {
    const [counter, setCounter] = useState(1);
    const { id, year, month }: any = useParams();
    const estadoEjecucionService = EstadosEjecucionService({ locale: 'en' });
    const paisesService = PaisesService({ locale: 'en' });
    const monedaService = MonedasService({ locale: 'en' });
    const tipoObraService = TipoObrasService({ locale: 'en' });
    const jefeEquipoService = JefeEquiposService({ locale: 'en' });
    const programasService = ProgramasService({ locale: 'en' });
    const notificationsService = NotificationsService({ locale: 'en' });
    const obrasService = ObrasService({ locale: 'en' });
    const [estadoEjecucion, setEstadoEjecucion] = useState<EstadoEjecucion[]>();
    const [obra, setObra] = useState(dataDefault);
    const [obras, setObras] = useState<ObraApp[]>([]);
    const [pais, setPais] = useState<Pais[]>();
    const [moneda, setMoneda] = useState<Moneda[]>();
    const [tipoObra, setTipoObra] = useState<TipoObra[]>();
    const [jefeEquipo, setjefeEquipo] = useState<JefeEquipo[]>();
    const today = new Date().getDate();
    const currentDate = new Date(year, month - 1, today);
    const filter: ObraFilter = {
        year: year,
        month: month,
        programa: id,
    };
    const min = new Date(year, month - 1, 1);
    const max = new Date(year, month, 0);

    useEffect(() => {
        const getPaises = paisesService.getPaises();
        const getMonedas = monedaService.getMonedas();
        const getTipoObras = tipoObraService.getTipoObras();
        const getJefeEquipos = jefeEquipoService.getJefeEquipos();
        const getProgramas = programasService.getProgramaPorId(id);
        const getEstadosEjecucion = estadoEjecucionService.getEstadosEjecucion();
        consumirObras(1, filter);
        Promise.all([
            getPaises,
            getMonedas,
            getTipoObras,
            getJefeEquipos,
            getProgramas,
            getEstadosEjecucion,
        ]).then((resp) => {
            setPais(resp[0].data.sort());
            setMoneda(resp[1].data.sort());
            setTipoObra(resp[2].data.sort());
            setjefeEquipo(resp[3].data.sort());
            setObra({
                ...obra,
                fecha: currentDate,
                programa: id,
                programItem: resp[4].data,
            });
            setEstadoEjecucion(resp[5].data.sort());
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function consumirObras(times: number, filter2: ObraFilter) {
        obrasService.getObrasApp(filter2).then((resp) => {
            if (resp.data.length <= 0 && times > 0) {
                if (filter2.month!.toString() === '1') {
                    filter2.year!--;
                    filter2.month = 12;
                } else {
                    filter2.month!--;
                }
                setCounter(0);
                consumirObras(0, filter2);
            } else {
                setObras(resp.data);
            }
        });
    }
    const handlerChange = ({ target }: any) => {
        const { value, name } = target;
        if (value) {
            switch (name) {
                case 'fecha':
                    setObra({ ...obra, fecha: value });
                    break;
                case 'pais':
                    setObra({ ...obra, pais: value.oid, paisItem: value });
                    break;
                case 'nombre':
                    setObra({ ...obra, nombre: value });
                    break;
                case 'moneda':
                    setObra({ ...obra, moneda: value.oid, monedaItem: value });
                    break;
                case 'montoInicial':
                    setObra({ ...obra, montoInicial: value });
                    break;
                // case "montoVigente":
                //     setObra({ ...obra, montoVigente: value });
                //     break;
                case 'fechaInicio':
                    setObra({ ...obra, fechaInicio: value });
                    break;
                case 'estadoEjecucion':
                    setObra({
                        ...obra,
                        estadoEjecucion: value.oid,
                        estadoEjecucionItem: value,
                    });
                    break;
                case 'plazoInicialMeses':
                    setObra({ ...obra, plazoInicialMeses: value });
                    break;
                case 'fechaFinalizacionVigente':
                    setObra({ ...obra, fechaFinalizacionVigente: value });
                    break;
                case 'fechaFinalizacionEstimada':
                    setObra({ ...obra, fechaFinalizacionEstimada: value });
                    break;
                // case "pagado":
                //     setObra({ ...obra, pagado: value });
                //     break;
                case 'jefeEquipo':
                    setObra({
                        ...obra,
                        jefeEquipoItem: value,
                        jefeEquipo: value.oid,
                    });
                    break;
                case 'tramo':
                    setObra({ ...obra, tramo: value });
                    break;
                case 'tipoObra':
                    setObra({
                        ...obra,
                        tipoObraItem: value,
                        tipoObra: value.oid,
                    });
                    break;
                case 'departamento':
                    setObra({ ...obra, provincia: value });
                    break;
                case 'longitudContrato':
                    setObra({ ...obra, longitudKm: value });
                    break;
                case 'bid':
                    setObra({ ...obra, porcentajeBid: value });
                    break;
                case 'contrapartida':
                    setObra({ ...obra, porcentajeContrapartida: value });
                    break;
                // case "mesUltPagoContratista":
                //         setObra({ ...obra, mesUltPagoContratista: value });
                //         break;
                default:
                    break;
            }
        }
    };

    const validateObras = (e: any) => {
        e.preventDefault();
        // tiene datos el mismo mes por lo que se creara una sola que sera la nueva.
        if (obras.length > 0 && counter > 0) {
            crearObraVacia();
        }
        // no tiene datos ese mes pero si el anterior por lo que se crearan las anteriores con la fecha actual mas la nueva.
        else if (obras.length > 0 && counter <= 0) {
            const result2: ObraApp[] = obras.filter((obra) => obra.estadoEjecucion !== 7);
            result2.push(obra);
            crearObraConDatos(result2);
            // no tiene datos ese mes y el anterior tampoco por lo que se creara la nueva.
        } else {
            crearObraVacia();
        }
    };

    const crearObraConDatos = (newObras: ObraApp[]) => {
        const currentDate = new Date(year, month - 1, today);
        for (let i = 0; i < newObras.length; i++) {
            newObras[i].fecha = currentDate;
            newObras[i].oid = 0;
        }
        const notification: NotificationAlert = {
            month: month,
            year: year,
            notificationDate: new Date(),
            notificationType: General.NotificationType.CreateObra,
            programId: id,
            statusId: 0,
            paisId: obra.pais,
        };
        notificationsService.addNotification(notification).then((resp) => {
            const newObra: ObraAppTemporal[] = newObras.map((ob: ObraApp) => {
                const obraTemp: ObraAppTemporal = {
                    ...ob,
                    notificationId: resp.data.id!,
                    oidObra: ob.oid!,
                };
                onChangeFuntions(obraTemp);
                return obraTemp;
            });
            obrasService.saveObrasAppTemporales(newObra).then((resp) => {
                activateAlert();
            });
        });
    };
    const crearObraVacia = () => {
        const notification: NotificationAlert = {
            month: month,
            year: year,
            notificationDate: new Date(),
            notificationType: General.NotificationType.CreateObra,
            programId: id,
            statusId: 0,
            paisId: obra.pais,
        };
        notificationsService.addNotification(notification).then((resp) => {
            const newObra: ObraAppTemporal = {
                ...obra,
                notificationId: resp.data.id,
                oidObra: obra.oid!,
            };
            obrasService.saveObrasAppTemporales([newObra]).then((resp) => {
                activateAlert();
            });
        });
    };
    const activateAlert = () => {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast: any) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
        });

        Toast.fire({
            icon: 'success',
            title: 'Obra Creada',
        }).then((resp) => {
            if (resp.isDismissed) {
                window.location.href = '/update-data';
            }
        });
    };

    return (
        <div className='obra-background'>
            <div className='obra-container'>
                <p>Crear Obra</p>
                <form onSubmit={validateObras} className='row col-12 d-flex'>
                    <div className='each col-md-6'>
                        <label>Fecha de creación</label>
                        <DatePicker
                            max={max}
                            min={min}
                            name='fecha'
                            onChange={handlerChange}
                            required
                            value={obra.fecha}
                            placeholder='Selecione una Fecha'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>País</label>
                        <ComboBox
                            data={pais}
                            name='pais'
                            onChange={handlerChange}
                            required
                            textField='nombre'
                            value={obra.paisItem}
                            placeholder='Selecione un país'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Nombre de la obra</label>
                        <Input
                            name='nombre'
                            onChange={handlerChange}
                            required
                            type='text'
                            placeholder='Especifique un nombre'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Moneda</label>
                        <ComboBox
                            data={moneda}
                            name='moneda'
                            onChange={handlerChange}
                            required
                            textField='nombre'
                            value={obra.monedaItem}
                            placeholder='Selecione una moneda'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Fecha de orden de inicio</label>
                        <DatePicker
                            required
                            placeholder='Seleccione una fecha'
                            name='fechaInicio'
                            onChange={handlerChange}
                            value={obra.fechaInicio}
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Monto contractual inicial</label>
                        <NumericTextBox
                            format='c2'
                            name='montoInicial'
                            onChange={handlerChange}
                            required
                            spinners={false}
                            value={obra.montoInicial}
                            placeholder='Monto inicial'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Tramo de la obra</label>
                        <Input
                            type='text'
                            required
                            name='tramo'
                            onChange={handlerChange}
                            placeholder='Tramo de la obra'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Tipo de Obra</label>
                        <ComboBox
                            required
                            data={tipoObra}
                            textField='descripcion'
                            name='tipoObra'
                            onChange={handlerChange}
                            value={obra.tipoObraItem}
                            placeholder='Seleccione un tipo'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Departamento/Provincia</label>
                        <Input
                            required
                            type='text'
                            name='departamento'
                            onChange={handlerChange}
                            placeholder='Departamento o Provincia'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Longitud total del contrato (km)</label>
                        <NumericTextBox
                            spinners={false}
                            required
                            name='longitudContrato'
                            onChange={handlerChange}
                            placeholder='Longitud total'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>% BID</label>
                        <NumericTextBox
                            spinners={false}
                            required
                            name='bid'
                            onChange={handlerChange}
                            format='p'
                            placeholder='Porcentaje BID'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>% Contrapartida</label>
                        <NumericTextBox
                            spinners={false}
                            required
                            name='contrapartida'
                            onChange={handlerChange}
                            format='p'
                            placeholder='Porcentaje contrapartida'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Fecha de finalización vigente</label>
                        <DatePicker
                            required
                            placeholder='Seleccione una fecha'
                            name='fechaFinalizacionVigente'
                            onChange={handlerChange}
                            value={obra.fechaFinalizacionVigente}
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Jefe de Equipo</label>
                        <ComboBox
                            required
                            data={jefeEquipo}
                            textField='nombre'
                            name='jefeEquipo'
                            onChange={handlerChange}
                            value={obra.jefeEquipoItem}
                            placeholder='Seleccione un Jefe de Eqipo'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Fecha de finalización estimada</label>
                        <DatePicker
                            required
                            placeholder='Seleccione una fecha'
                            name='fechaFinalizacionEstimada'
                            onChange={handlerChange}
                            value={obra.fechaFinalizacionEstimada}
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Plazo contractual inicial</label>
                        <NumericTextBox
                            spinners={false}
                            required
                            name='plazoInicialMeses'
                            onChange={handlerChange}
                            value={obra.plazoInicialMeses}
                            placeholder='Escriba el plazo en meses'
                        />
                    </div>
                    <div className='each col-md-6'>
                        <label>Estado de Ejecución</label>
                        <ComboBox
                            required
                            data={estadoEjecucion}
                            textField='nombre'
                            name='estadoEjecucion'
                            onChange={handlerChange}
                            value={obra.estadoEjecucionItem}
                            placeholder='Seleccione un estado de ejecución'
                        />
                    </div>
                    {/* <div className="each col-md-6">
                        <label>Mes último pago al contratista</label>
                        <DatePicker
                            required
                            onChange={handlerChange}
                            name="mesUltPagoContratista"
                            value={obra.mesUltPagoContratista}
                        />
                    </div> */}
                    <div className='obra-buttons'>
                        <Link className='link--to--country' to='/create-program'>
                            <button className='btn-back'>Volver</button>
                        </Link>
                        <button className='btn-create'>Crear Obra</button>
                    </div>
                </form>
            </div>
        </div>
    );
};
